import { useCallback } from "react";
import { getLowerCaseString } from "helpers/function";

export const useSearch = (rapportAuto) => {
  const getEmailString = useCallback((email) => {
    let emailString = "";
    if (!email || !Array.isArray(email)) return emailString;

    email.forEach((mail, index) => {
      emailString += index === email.length - 1 ? mail : mail + "/ ";
    });
    return emailString;
  }, []);

  const filterBySearchValue = useCallback(
    (value) => {
      const searchValue = getLowerCaseString(value);
      let filteredRapportAuto = [...rapportAuto];

      filteredRapportAuto = filteredRapportAuto.filter((el) => {
        const institutionName = el.institution_targeted
          ? el.institution_targeted.name
          : "";
        const institutionMatch =
          getLowerCaseString(institutionName).indexOf(searchValue) >= 0;

        const periodLabel = el.period ? el.period_tag?.label || "" : "";
        const periodMatch =
          getLowerCaseString(periodLabel).indexOf(searchValue) >= 0;

        let emailMatch = false;
        if (Array.isArray(el.email)) {
          emailMatch =
            getLowerCaseString(getEmailString(el.email)).indexOf(searchValue) >=
            0;
        } else if (el.email) {
          emailMatch = getLowerCaseString(el.email).indexOf(searchValue) >= 0;
        }

        return institutionMatch || periodMatch || emailMatch;
      });

      return filteredRapportAuto;
    },
    [rapportAuto, getEmailString]
  );

  const searchElement = useCallback(
    (searchValue) => {
      if (searchValue && searchValue.trim()) {
        return filterBySearchValue(searchValue);
      } else {
        return rapportAuto;
      }
    },
    [rapportAuto, filterBySearchValue]
  );

  return {
    searchElement,
    filterBySearchValue,
    getEmailString,
  };
};
